import React, { useState } from 'react'
import {
  Select,
  Button,
  Upload,
  message
} from 'antd'
import 'moment/locale/zh-cn'
import _lodash, { cloneDeep, get, remove } from 'lodash'
import common from '@/public/common'
import styles from './index.module.less'
import {CloseCircleOutlined, EyeOutlined, PlusOutlined} from '@ant-design/icons'
import imgexample from '@/static/img/imgexample.png'
import { tokenConfig } from '@/public/utils'
const SixFacesChart = (props) => {
  const { getCurrent } = props
  const [addData, setaddData] = useState(
    JSON.parse(sessionStorage.getItem('addData'))
  )
  const [fileList,setFileList] = useState([])
  let isType = true

  const handleBeforeUploadResponsibility = (e) => {
    const type = e.type.split('/')[1]
    if (type === 'jpeg' || type === 'jpg' || type === 'png') {
      isType = true
    } else {
      isType = false
    }
    if (!isType) {
      message.warning('图片上传只支持.jpeg、.jpg、.png')
      return Upload.LIST_IGNOREE
    }
  }
  //
  const handleChangeSixPicter = (e) => {
    if (isType) {
      const addDataClone = _lodash.clone(addData)
      if (e.file.status === 'done') {
        var imglist = []
        e.fileList.map(item=>{
          if(get(item,'response.url')){
            imglist.push(item)
          }
        })
        if (imglist !== 0) {
          imglist.forEach((item) => {
              addDataClone.six_images.push(item.response.url)
          })
        }
        addDataClone.six_images = _lodash.uniqWith(addDataClone.six_images, _lodash.isEqual)
        setaddData(addDataClone)
        sessionStorage.setItem('addData', JSON.stringify(addDataClone))
      }else if((e.file.status === 'error')){
        message.error(_lodash.get(e.file,'response.message'))
      }
      setFileList(e.fileList)
    }
  }

  const getFileList=(list)=>{
    if(get(fileList,'length')){
      return fileList
    }
    var cloneList = []
    if(get(list,'length')){
      list.map((item,index)=>{
        cloneList.push({uid:index,url:item})
      })
    }
    return cloneList
  }

  // 删除图片
  const handleDeleteSixImage = (e, index) => {
    const addDataClone = _lodash.clone(addData)
    addDataClone.six_images.splice(index, 1)
    setFileList(cloneDeep(remove(fileList,function(n){return get(n,"response.url")===e})))
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }
  // 下一步
  const handleNext = () => {
    if (addData && addData.six_images.length === 0) {
      message.warning('请上传图片', 2)
      return
    }
    getCurrent(2)
  }

  //  上一步
  const handleBack = () => {
    getCurrent(0)
  }

  const uploadButton = (
    <div style={{ position: 'relative' }}>
      <PlusOutlined />
      <div className="ant-upload-text">上传</div>
    </div>
  )

  return (
    <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
      <div style={{ width: '100%' }}>
        <div
          style={{
            width: '100%',
            marginBottom: '24px',
            marginTop: '56px',
            textAlign: 'center'
          }}
        >
          <div style={{ marginLeft: '32px', textAlign: 'left', color: 'red' }}>
            注：请上传完整，
            要求：六面图清晰完整，必须带公章
          </div>

          <div
            style={{
              border: '1px solid lavender',
              margin: '0px 32px 32px 32px',
              padding: '16px 16px'
            }}
          >
            <span
              style={{
                display: 'flex'
              // width: "7%",
              // position:'relative'
              }}
              className={styles.uploadimg}
            >
              <span>
                {addData &&
                addData.six_images &&
                addData.six_images.length !== 0
                  ? addData.six_images.map((j, k) => {
                    return (
                      <span className={styles.img_style} key={k}>
                        <span className={styles.imgstyle}>
                          <a
                            href={j}
                            className={styles.iconstyle}
                            style={{
                              fontSize: '18px',
                              color: 'white'
                            }}
                            target="_blank"
                          >
                            <EyeOutlined />
                          </a>

                          <CloseCircleOutlined
                            className={styles.iconstyles}
                            style={{
                              position: 'absolute',
                              top: '-4px',
                              right: '-6px'
                            }}
                            onClick={() => handleDeleteSixImage(j, k)}
                            type="close-circle"
                          />
                        </span>
                        <img
                          src={j}
                          style={{
                            width: '100%',
                            height: '100%'
                          }}
                        ></img>
                      </span>
                    )
                  })
                  : null}
              </span>
              <Upload
                action={common.scpUrl + 'item/upload-file'}
                headers={{...tokenConfig}}
                listType="picture-card"
                multiple={true}
                accept="image/jpeg,image/jpg,image/png"
                fileList={getFileList(addData.six_images || [])}
                beforeUpload={handleBeforeUploadResponsibility}
                onChange={handleChangeSixPicter}
              >
                { addData.six_images.length > 50 ? null : uploadButton}
              </Upload>
            </span>
            <div style={{color: "#cccccc",textAlign:"left"}}>按住键盘CTAL键可多选</div>
          </div>
          <div style={{ marginLeft: '32px', textAlign: 'left' }}>实例：六面图</div>

          <div
            style={{
              border: '1px solid lavender',
              margin: '0px 32px 32px 32px',
              padding: '16px 16px'
            }}>
            <img style={{width: '100%'}} src={imgexample}></img>
          </div>

          <Button
            type=""
            style={{ margin: '0px 8px' }}
            onClick={handleBack}
            shape="round"
          >
            上一步
          </Button>
          <Button
            type=""
            style={{ margin: '0px 8px' }}
            onClick={handleNext}
            shape="round"
          >
            下一步
          </Button>
        </div>
      </div>
    </div>
  )
}
export default SixFacesChart



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/six-faces-chart.js